import { error, finish } from '../../../modules/liabilities/actions/multiple';

export function request(dispatch, { id, eventId }) {
    $appState.trpcClient.getMultiplesLiabilities({ eventId: eventId, marketId: id })
        .then(liabilities => {
            const data = Object.assign(liabilities, {eventId: eventId});
            dispatch(finish(id, data));
        })
        .catch(
            errors => dispatch(error(id, errors))
        );
}
